import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '../../../../../../context/AuthContext';
import { Button, Form } from 'react-bootstrap';
import { db } from '../../../../../../firebase';
import { collection, doc, onSnapshot, query, setDoc } from 'firebase/firestore';
import { format } from 'date-fns';

const NoteComment = ({ leadID, activityID, selectedActivity, setSelectedActivity }) => {
  const { user, businessUsers } = useAuth();
  const { bid } = user.claims;

  const contentRef = useRef(null);

  const [data, setData] = useState(null);
  const [commentData, setCommentData] = useState({
    comment: "",
    createdBy: user?.uid || "",
    createdAt: new Date()
  });
  const [contentHeight, setContentHeight] = useState(100);

  function getActivityComments() {
    const q = query(collection(db, "Businesses", bid, "Leads", leadID, "Activities", activityID, "Comments"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const tempData = [];
      querySnapshot.forEach((doc) => {
        tempData.push({ id: doc.id, ...doc.data() });
      });

      setData(tempData);
    });

    return () => unsubscribe;
  }

  useEffect(() => {
    getActivityComments();
    setContentHeight(contentRef.current?.scrollHeight || 0);
  }, []);

  async function handleCommentData() {
    const commentRef = doc(collection(db, "Businesses", bid, "Leads", leadID, "Activities", activityID, "Comments"));
    await setDoc(commentRef, commentData);

    setCommentData({
      comment: "",
      createdBy: user?.uid || "",
      createdAt: new Date()
    });
  }

  return (
    <div>
      <div className='mt-3'>
        {
          data && data.map((item, index) => {
            return (
              <div key={index} className='bg-primary-light border rounded text-secondary p-3 mt-3'>
                <p className='mb-0 text-dark'>{item?.comment || "-"}</p>
                <div className='d-flex align-items-center justify-content-between mt-3'>
                  <p className='mb-0 small fw-light mt-2'>Created By <span className='fw-normal'>{businessUsers && businessUsers.find(x => x.id === item.createdBy)?.name || "-"}</span></p>
                  <p className='mb-0 small fw-light mt-2'>{item?.createdAt ? format(new Date(item.createdAt.seconds * 1000), "d MMM yyyy, h:mm a") : "-"}</p>
                </div>
              </div>
            )
          })
        }
      </div>
      <div
        ref={contentRef}
        style={{
          overflow: 'hidden',
          maxHeight: selectedActivity === activityID ? contentHeight : 0,
          transition: 'maxHeight 0.3s ease-in-out',
        }}
      >
        <Form.Group className="my-3">
          <Form.Control
            type="text"
            as="textarea"
            rows={4}
            placeholder="Comment here..."
            className='bg-primary-light'
            onChange={(event) => setCommentData({ ...commentData, comment: event.target.value })}
            value={commentData && commentData.comment}
          />
        </Form.Group>
        <div className='d-flex align-items-center justify-content-end mb-2'>
          <Button
            variant='light'
            className='py-2 px-3 border me-2'
            onClick={() => setSelectedActivity(null)}
          >
            Cancel
          </Button>
          <Button
            disabled={commentData && commentData.comment ? false : true}
            variant='primary'
            className='py-2 px-4 ms-2'
            onClick={() => handleCommentData()}
          >
            Save
          </Button>
        </div>
      </div>
    </div >
  )
}

export default NoteComment;
